import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AreasService } from "../../master-services/area-services/areas.service";
import { Router } from "@angular/router";
import swal from "sweetalert2";

@Component({
  selector: "app-manage-area-user",
  templateUrl: "./manage-area-user.componet.html",
  styleUrls: ["./manage-area-user.componet.scss"],
})
export class MasterareaUserComponent implements OnInit {
  areas: any;
  UserId: number = Number(localStorage.getItem('userid'))
  constructor(private AreasService: AreasService, private router: Router) {
    this.getArea();
  }

  ngOnInit() {}

  //Genera el listado de la tabla
  getArea() {
    this.AreasService.getAreaForUser(this.UserId)
      .then((data) => {
        const resp: any = data;
        swal.close();
        this.areas = resp.data;
      })
      .catch((error) => {
        // console.log(error);
      });
  }

  managearea(id: any) {
    this.router.navigateByUrl("erp/manageArea/" + id);
    localStorage.removeItem("idarea");
    localStorage.setItem("idarea", id);
  }
}



// WEBPACK FOOTER //
// ./src/app/master/manage-area-user/manage-area-user.componet.ts